import { BaseMutations } from '@/store/base-mutations';
import { Reports } from '@/modules/reports/types';
import { default_mutuals_reports_filters } from '@/modules/reports/services';
import ReportsMutualsState from './state';

export default class ReportsMutualsMutations extends BaseMutations<ReportsMutualsState> {
  SET_MUTUALS(mutuals: Reports.Mutual[]) {
    this.state.mutuals = mutuals;
  }

  SET_ORGANIZATIONS(organizations: Reports.Organization[]) {
    this.state.organizations = organizations;
  }

  SET_EXTERNAL_ORGANIZATION(external_organizations: Reports.ExternalOrganization[]) {
    this.state.external_organizations = external_organizations;
  }

  SET_CONTRACTS(contracts: Reports.Contract[]) {
    this.state.contracts = contracts;
  }

  SET_DEBT_INFO(debt_info: Reports.MutualsDebtInfo) {
    this.state.debt_info = debt_info;
  }

  UPD_SHOW_TABLES(value: boolean) {
    this.state.show_tables = value;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof Reports.MutualsReportsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_IS_DOWNLOAD(is_download: boolean) {
    this.state.is_download = is_download;
  }

  RESET_PAYLOAD() {
    this.state.filters = default_mutuals_reports_filters();
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  TOGGLE_IS_DOWNLOAD_LOADING(toggle: boolean) {
    this.state.is_download_loading = toggle;
  }
}
